<div class="w-full flex flex-col gap-[6px]">
  <span class="font-[500] text-[14px] text-[#6B7280]">{{ label }}</span>
   <div class="w-full relative grid grid-cols-[95%_1fr] items-center justify-between border h-[52px] {{error ? 'border-[#FF0000]' : 'border-gray-300'}} {{error ? 'focus-within:border-[#FF0000]' : 'focus-within:border-[#081A46]'}} focus-within:ring-[0.5px] bg-white px-[13px] rounded-[10px]">
    <input
    [(ngModel)]="inputValue"
    class="font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-white outline-none"
    placeholder="{{ placeholder }}"
    (keyup)="onInputChange($event)"
    [type]="type === 'password' && !passwordVisible ? 'password' : 'text'"
  />
  <img (click)="showPassword()" *ngIf="type === 'password'" class="w-[20px] h-[20px] cursor-pointer" [src]="!passwordVisible ? '../../../assets/icons/Eye.svg' : '../../../assets/icons/eye-hidden.svg'" alt="">
   </div>
  <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>

<!-- <div class="w-full flex flex-col gap-[6px]">
  <span class="font-[500] text-[14px] text-[#6B7280]">{{ label }}</span>
    <input
    [(ngModel)]="inputValue"
    class="h-[52px] border {{error ? 'border-[#FF0000]' : 'border-gray-300'}} focus:ring-[0.5px] focus:border-[#081A46] font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-white rounded-[10px] px-[13px] outline-none"
    placeholder="{{ placeholder }}"
    (keyup)="onInputChange($event)"
    type="{{ type }}"
  />
  <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div> -->

<!-- <div class="w-full flex flex-col gap-[6px]">
    <span class="font-[800] text-[14px] text-[#6B7280]">{{ label }}</span>
    <input
      [(ngModel)]="inputValue"
      class="h-[52px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
      placeholder="{{ placeholder }}"
      (keyup)="onInputChange($event)"
      type="{{ type }}"
    />
    <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
  </div> -->